<template>
	<div class="input__wrapper">
		<span class="checkbox-list-title">{{ data.label }}</span>
		<ul class="checkbox-list">
			<li v-for="item in data.items" :key="item.id">
				<label class="checkbox-list__label" :for="item.for">
					<input
						class="checkbox-list__input"
						type="checkbox"
						:id="item.id"
						:value="item.value"
						:checked="item.checked"
						>
					<span class="checkbox-list__input-text">{{ item.name }}</span>
					<span class="checkmark"></span>
				</label>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	props: {
		value: [String, Number],
		type: {
			type: String,
			default: 'text'
		},
		data: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			inputVal: this.value
		};
	},

	watch: {
		inputVal (val) {
			this.$emit('input', val);
		}
	}
};
</script>
<style lang="scss" scoped>
.checkbox-list-title {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $slate-gray;
	margin-bottom: 14px;
    display: block;

	@include mq($sm) {
		font-size: 16px;
	}
}

.checkbox-list__input-text {
	font-family: $font-main;
	font-size: 16px;
	line-height: 25px;
	align-items: center;
	color: $fiord;
}

.checkbox-list {
	padding-left: 4px;

	li {
		display: flex;
		align-items: center;
		margin-bottom: 14px;
		position: relative;
	}
}
.checkbox-list__input {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $fiord;
	min-width: 18px;
	width: 17px;
    height: 17px;
    margin-right: 10px;
	transition: $dur $ease;
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

.checkbox-list__label {
	margin-bottom: 0;
	font-size: 14px;
	padding-left: 28px;

	@include mq($xl) {
		display: flex;
		align-items: center;
	}
}

.checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 18px;
	width: 18px;
	background-color: $white;
	border: 2px solid $fiord;
	transition: $dur $ease;
}

input:checked ~ .checkmark {
	background-color: $dodger-blue;
	border: 2px solid $dodger-blue;
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

input:checked ~ .checkmark:after {
	display: block;
	transition: $dur $ease;
}

.checkmark:after {
	left: 4px;
    top: 1px;
    width: 6px;
    height: 10px;
	border: solid $white;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
	transition: $dur $ease;
}
</style>
